module.exports = __webpack_public_path__ + "static/media/service_online_3.db337038.png";